import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  private _showHeader = new BehaviorSubject<boolean>(true);
  showHeader$ = this._showHeader.asObservable();

  setShowHeader(value: boolean) {
    this._showHeader.next(value);
  }
}